import { createI18n } from 'vue-i18n'
import {
  de as vuetifyDe,
  en as vuetifyEn,
  fr as vuetifyFr,
} from 'vuetify/locale'

import commonDe from '../locales/de/common.json'
import componentDe from '../locales/de/components.json'
import commonEn from '../locales/en/common.json'
import componentEn from '../locales/en/components.json'
import commonFr from '../locales/fr/common.json'
import componentFr from '../locales/fr/components.json'

const fallbackLocalePriorities = ['en', 'fr', 'de']

const loadLocaleMessages = () => {
  const paginationNumbers = {
    '10': '10',
    '25': '25',
    '50': '50',
    '100': '100',
  }

  return {
    de: {
      ...paginationNumbers,
      ...componentDe,
      common: {
        ...componentDe.common,
        ...commonDe.common,
      },
      $vuetify: vuetifyDe,
    },
    en: {
      ...paginationNumbers,
      ...componentEn,
      common: {
        ...componentEn.common,
        ...commonEn.common,
      },
      $vuetify: vuetifyEn,
    },
    fr: {
      ...paginationNumbers,
      ...componentFr,
      common: {
        ...componentFr.common,
        ...commonFr.common,
      },
      $vuetify: vuetifyFr,
    },
  }
}

const navigatorLanguage = navigator?.language.slice(0, 2)

export default createI18n({
  locale: navigatorLanguage,
  fallbackLocale: fallbackLocalePriorities,
  messages: loadLocaleMessages(),
  // modifiers: {
  //   initials: (message) => message.split(' ').reduce((acc, m) => acc + m.toUpperCase()[0], ''),
  // },
  numberFormats: {
    'en': {
      decimal: { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2 },
    },
    'fr': {
      decimal: { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2 },
    },
    'de': {
      decimal: { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2 },
    },
  },
  legacy: false,
  globalInjection: true,
})

export type AvailableLocale = keyof ReturnType<typeof loadLocaleMessages>
